import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

export const StyledSearchButton = styled.button`
  padding: 0;

  text-align: start;

  border: none;

  background: none;

  cursor: pointer;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${theme.breakpoints.up("tablet")} {
    gap: 12px;
  }
`;

export const StyledTopic = styled.div`
  ${theme.breakpoints.up("tablet")} {
    &:not(:last-of-type) {
      padding-block-end: 12px;

      border-block-end: 1px solid #dfdfdf;
    }
  }

  ${StyledSearchButton} {
    color: #333333;
    font-weight: 400;
    font-size: 15px;
    font-family: ${fontRoboto};
    line-height: normal;

    ${theme.breakpoints.up("tablet")} {
      font-size: 16px;
    }
  }
`;
